//path: 路由路径,rePath: 重定向路径,name: 路由名称,children: 子路由,regex: 路由正则匹配,当有相同路由时，会从父路由中寻找匹配的子路由，如果没有匹配的子路由，则会匹配父路由
import i18n from '../assets/i18n'
const routerPath = [{
        path: '/',
        name: i18n.t('route.Home'),
    },
    {
        path: '/companyProfile',
        name: i18n.t('route.companyProfile'),
        rePath: '/companyProfile/3004',
        children: [{
                path: '/companyProfile/3004',
                name: i18n.t("companyProfile.companyProfile"),
            },
            // {
            //     path: '/companyProfile/3013',
            //     name: i18n.t("companyProfile.companyStructure"),
            // },
            // {
            //     path: '/companyProfile/3005',
            //     name: i18n.t("companyProfile.corporateCulture"),
            // },
            {
                path: '/companyProfile/3006',
                name: i18n.t("companyProfile.corporateHonor"),
            },
            {
                path: '/companyProfile/3007',
                name: i18n.t("companyProfile.development"),
            },
            {
                path: '/companyProfile/3008',
                name: i18n.t("companyProfile.customers"),
            },
            {
                path: '/companyProfile/3009',
                name: i18n.t("companyProfile.partners"),
            },
            {
                path: '/companyProfile/3010',
                name: i18n.t("companyProfile.chinaSouthernAirlines"),
            }
        ]
    },
    {
        path: '/newsInformation',
        name: i18n.t('route.newsInformation'),
        children: [{
                path: '/news_list?id=3000',
                name: i18n.t('news.companyNews'),
                children: [{
                    path: '/newsDetail',
                    name: i18n.t('news.newsDetail'),
                    regex: /[\?\/][^\/\?]*$/
                }]
            },
            {
                path: '/news_list?id=3001',
                name: i18n.t('news.industryNews'),
                children: [{
                    path: '/newsDetail',
                    name: i18n.t('news.dynamicDetail'),
                    regex: /[\?\/][^\/\?]*$/
                }]
            },
            {
                path: '/news_list?id=3014',
                name: i18n.t('news.informationDisclosure'),
                children: [{
                    path: '/newsDetail',
                    name: i18n.t('news.informationDetail'),
                    regex: /[\?\/][^\/\?]*$/
                }]
            },
            {
                path: '/newsDetail',
                name: i18n.t('news.detail'),
                regex: /[\?\/][^\/\?]*$/
            }
        ]
    },
    {
        path: '/product',
        name: i18n.t('route.ProductCenter'),
        children: [{
            path: '/productCenter/productCard',
            name: i18n.t('productCenter.productDetail'),
            regex: /[\?\/][^\/\?]*$/
        }]
    },
    {
        path: '/pilotService',
        name: i18n.t("route.Pilot"),
        children: [{
                path: '/pilotService/planQuery',
                name: i18n.t("pilotService.planQuery")
            },
            {
                path: '/pilotService/planQuery/second',
                name: i18n.t("pilotService.planQuery"),
            },
            {
                path: '/pilotService/questionnaireInvestigation',
                name: i18n.t("pilotService.QuestionnaireInvestigation"),
                children: [{
                    path: '/pilotService/questionnaireInvestigation',
                    name: i18n.t("pilotService.questionnaireDetails"),
                    regex: /[\?\/][^\/\?]*$/
                }]
            },
            {
                path: '/pilotService/articleCenter/3011',
                name: i18n.t("pilotService.Training"),
            }
        ]
    },
    {
        name: i18n.t("route.Contact"),
        rePath: '/ContactUs',
        children: [{
                path: '/ContactUs',
                name: i18n.t("contactUs.contactInformation"),
            },
            {
                path: '/ContactUs/talentRecruitment',
                name: i18n.t("contactUs.talentRecruitment"),
                children: [{
                    path: '/ContactUs/talentRecruitment/positionDetails',
                    name: i18n.t("contactUs.positionDetails"),
                    regex: /[\?\/][^\/\?]*$/
                }]
            },
        ]
    },
    {
        path: '/legalStatement',
        name: i18n.t("legalAndMap.legalStatement"),
    },
    {
        path: '/legalStatement/siteMap',
        name: i18n.t("legalAndMap.siteMap"),
    }
]

export default routerPath